export default "__VITE_ASSET__ef037941__"